import './LinkButton.css';

import React from 'react';

const LinkButton = (
  props: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
) => (
  <button {...props} className="LinkButton">
    {props.children}
  </button>
);

export default LinkButton;
